// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"252":"7a6eb080","260":"af296618","408":"e6e4fb19","626":"08aea034"}[chunkId] + ".chunk.css";
};